import { Circle as CircleIcon } from '@mui/icons-material';

const Circle = (): JSX.Element => <CircleIcon fontSize="inherit" />;

export default Circle;
